import {
    ArrowDownNarrowWide,
    ArrowUpDown,
    ArrowUpNarrowWide,
    BookMinus,
    ChevronDown,
    ChevronFirst,
    ChevronLast,
    ChevronLeft,
    ChevronRight,
    ChevronsDown,
    CircleX,
    Columns3Cog,
    Copy,
    Ellipsis,
    EllipsisVertical,
    EyeOff,
    Funnel,
    FunnelPlus,
    FunnelX,
    GripVertical,
    Maximize,
    Maximize2,
    Minimize,
    Pin,
    PinOff,
    Rows2,
    Rows3,
    Rows4,
    Save,
    Search,
    SearchX,
    SquarePen,
    X,
} from 'lucide-react';

export const MRT_Default_Icons = {
    IconArrowAutofitContent: Maximize2,
    IconArrowsSort: ArrowUpDown,
    IconBaselineDensityLarge: Rows4,
    IconBaselineDensityMedium: Rows3,
    IconBaselineDensitySmall: Rows2,
    IconBoxMultiple: Copy,
    IconChevronDown: ChevronDown,
    IconChevronLeft: ChevronLeft,
    IconChevronLeftPipe: ChevronFirst,
    IconChevronRight: ChevronRight,
    IconChevronRightPipe: ChevronLast,
    IconChevronsDown: ChevronsDown,
    IconCircleX: CircleX,
    IconClearAll: BookMinus,
    IconColumns: Columns3Cog,
    IconDeviceFloppy: Save,
    IconDots: Ellipsis,
    IconDotsVertical: EllipsisVertical,
    IconEdit: SquarePen,
    IconEyeOff: EyeOff,
    IconFilter: Funnel,
    IconFilterCog: FunnelPlus,
    IconFilterOff: FunnelX,
    IconGripHorizontal: GripVertical,
    IconMaximize: Maximize,
    IconMinimize: Minimize,
    IconPinned: Pin,
    IconPinnedOff: PinOff,
    IconSearch: Search,
    IconSearchOff: SearchX,
    IconSortAscending: ArrowUpNarrowWide,
    IconSortDescending: ArrowDownNarrowWide,
    IconX: X,
} as const;

export type MRT_Icons = Record<keyof typeof MRT_Default_Icons, any>;
